<template>
  <modal
    name="editGroupOrder"
    :display-header-title="false"
    modal-style="compact"
  >
    <edit-group-order />
  </modal>
</template>


<script>
  import EditGroupOrder from './edit-group-order/index.vue';


  export default {
    name: 'EditGroupOrderModal',

    components: {
      EditGroupOrder
    }
  };
</script>
